import {
  colors,
  Button,
  withStyles,
  IconButton,
  makeStyles,
} from "@material-ui/core";
import React, { ReactNode } from "react";
import { useIntl } from "react-intl";
import { CustomTooltip } from "./Tooltip";

export const ApproveButton = withStyles((theme) => ({
  root: {
    backgroundColor: colors.green[700],
    color: theme.palette.common.white,
    borderRadius: 3,
    fontSize: 14,
    padding: "4px 12px",

    "&:hover": {
      backgroundColor: colors.green[600],
    },

    "&:disabled": {
      color: theme.palette.common.white,
      backgroundColor: colors.green[200],
    },
  },

  label: {
    textTransform: "none",
  },
}))((props: any) => <Button {...props} />);

export const DeclineButton = withStyles((theme) => ({
  root: {
    backgroundColor: colors.red[700],
    color: theme.palette.common.white,
    borderRadius: 3,
    fontSize: 14,
    padding: "4px 12px",

    "&:hover": {
      backgroundColor: colors.red[500],
    },

    "&:disabled": {
      color: theme.palette.common.white,
      backgroundColor: colors.red[200],
    },
  },

  label: {
    textTransform: "none",
  },
}))((props: any) => <Button {...props} />);

export const OutlineButton = withStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.common.white,
    // color: theme.palette.text.primary,
    borderRadius: 3,
    fontSize: 14,
    padding: "3px 12px",
    border: "1px solid #D9D9D9",
    color: colors.grey[700],

    "&:hover": {
      backgroundColor: "#fafafa",
    },

    "&:disabled": {
      color: colors.grey[600],
      backgroundColor: "#f6f6f6",
    },
  },

  label: {
    textTransform: "none",
  },
}))((props: any) => <Button {...props} />);

export const DefaultButton = withStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.common.white,
    borderRadius: 3,
    fontSize: 14,
    padding: "4px 12px",

    "&:hover": {
      backgroundColor: theme.palette.secondary.main,
      opacity: 0.8,
    },

    "&:disabled": {
      opacity: 0.8,
      color: theme.palette.common.white,
      backgroundColor: theme.palette.secondary.main,
    },
  },

  label: {
    textTransform: "none",
  },
}))((props: any) => <Button {...props} />);

export interface ActionButtonProps {
  children: ReactNode;
  ariaLabel: string;
  size?: "small" | "medium";
  customColor?: string;
  title?: string;

  onClick?: (event: any) => void;
}

export const useIconButtonStyles = makeStyles(
  (theme) => ({
    root: {
      color: (props: ActionButtonProps) =>
        !props.customColor ? "#0072E5" : props.customColor,
      padding: 6,
      marginLeft: theme.spacing(2),
    },
  }),
  {
    name: "custom-icon-button-style",
    flip: null,
  }
);

export const ActionButton = (props: ActionButtonProps) => {
  const classes = useIconButtonStyles(props);
  const intl = useIntl();
  // Props
  const { children, ariaLabel, size, title, onClick } = props;

  return (
    <CustomTooltip
      title={title ?? intl.formatMessage({ id: "sharedScreen.action" })}
      arrow
    >
      <IconButton
        color="primary"
        aria-label={ariaLabel}
        size={size}
        classes={classes}
        onClick={onClick}
      >
        {children}
      </IconButton>
    </CustomTooltip>
  );
};

ActionButton.defaultProps = {
  size: "small",
  color: "#0072E5",
};
